import { BaseApi, type RequestHeaders, type RequestParams, type SuccessResponse } from '@bv/api/base';

export class WithDelete<Item extends Record<string, any> = object> extends BaseApi {
  /**
   * Creates an instance of the child class.
   * This constructor passes the endpoint to the parent class's constructor.
   * @param {string} endpoint - The API endpoint that will be passed up to the base class constructor.
   */
  public constructor(endpoint: string) {
    super(endpoint);
  }

  /**
   * Delete item
   * @param {string|number} [id] - Item ID.
   * @param {Object} [config] - Configuration for the request.
   * @param {RequestParams} [config.params] - Additional query parameters to send with the request.
   * @param {RequestHeaders} [config.headers] - Custom HTTP headers to send with the request.
   * @returns {Promise<SuccessResponse>}
   * @public
   */
  public async delete(
    id: string | number,
    {
      params,
      headers,
    }: {
      params?: RequestParams;
      headers?: RequestHeaders;
    } = {},
  ): Promise<SuccessResponse> {
    return this.request<Item, SuccessResponse>({
      method: 'delete',
      url: id.toString(),
      params,
      headers,
    });
  }
}
